export default {
	trendingTracks: '/trending-tracks',
	topTracks: '/top-tracks',
};
